<script lang="ts">
  import type { VoiceType } from 'shared/definitions/musicTheory/voiceTypes';
  import { singersByVoiceType } from 'shared/definitions/musicTheory/voiceTypes';
  import { listToString } from 'shared/src/utils/listToString';
  import { createEventDispatcher } from 'svelte';
  import { fly, scale } from 'svelte/transition';
  import VoiceTypeSelect from './VoiceTypeSelect.svelte';

  export let height: number;
  export let gameOver = false;
  export let voiceType: VoiceType;

  const dispatch = createEventDispatcher<{ startClicked: null }>();
</script>

<div class="start-screen-wrapper">
  <div
    id="gameName"
    out:fly|local={{ y: -100 }}
    in:fly|local={{ y: 100 }}
    style="font-size: {height * 0.08}px;"
  >
    {gameOver ? 'Game Over!' : 'Pitchy Fish'}
  </div>
  <div class="voice-select" style="font-size: {height * 0.05}px;" out:scale|local in:scale|local>
    <p class="m-4">What kind of fish are you?</p>
    <VoiceTypeSelect class="block" bind:voiceType />
    <p class="m-4">
      ...like {listToString(singersByVoiceType[voiceType])}
    </p>
  </div>
  <button
    id="startButton"
    on:click={() => dispatch('startClicked')}
    out:fly|local={{ y: 100 }}
    in:fly|local={{ y: -100 }}
    style="font-size: {height * 0.05}px;">{gameOver ? 'Try Again' : 'Start Game!'}</button
  >
  <img
    class="absolute -left-full -top-full opacity-0 h-0 w-0"
    src="/assets/pitchy-fish/pier.png"
    alt="Pier from below water."
    aria-hidden
  />
</div>

<style lang="postcss">
  .start-screen-wrapper {
    position: relative;
    margin: auto;
    top: 0%;
    height: 100%;
    width: 90%;
    text-align: center;
    z-index: 40;
  }

  #gameName {
    font-family: 'Luckiest Guy', Impact, 'Arial Narrow Bold', sans-serif;
    color: #ffc400;
    top: 12%;
    width: 100%;
    text-align: center;
    position: absolute;
    text-shadow: 4px 4px 10px black;
    user-select: none;
  }

  .voice-select {
    position: absolute;
    top: 24%;
    width: 100%;
    font-size: 0.4em;
  }

  #startButton {
    font-family: 'Luckiest Guy', Impact, 'Arial Narrow Bold', sans-serif;
    padding: 0;
    /** padding-top seems to adjust for false vertical centering of this font. */
    padding-top: 10%;
    padding-bottom: 10%;
    text-align: center;
    position: absolute;
    left: 10%;
    bottom: 8%;
    width: 80%;
    font-size: 100%;
    border-radius: 8%;
    color: black;
    background: linear-gradient(coral, rgb(217, 255, 0));
    user-select: none;
  }
</style>
